<template>
  <div class="home">
    <!-- Popup -->
    <div
        v-if="showPopup"
        class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center popup"
    >
      <div class="bg-white p-6 rounded-lg max-w-6xl shadow-lg text-left max-h-[80vh] overflow-y-auto">

        <!-- GRID -->
        <div class="grid grid-cols-12 mt-8 mb-12 ml-4 mr-4">
          <div class="col-span-12 ">

          <!-- BILD (auf Mobile oben, auf Desktop rechts)
          <div class="order-1 md:order-2">
            <img
                src="../assets/ostern.png"
                alt="Ostern"
                class="w-full h-auto rounded-lg object-cover"
            />
          </div>-->

          <!-- TEXT -->
            <h2 class="text-3xl font-bold mb-4">Technische Probleme</h2>

            <p class="mb-4">
              Liebe Patientinnen und Patienten,
              liebe Familien und Angehörige,
            </p>

            <p class="mb-4">
              leider haben wir aktuell Probleme mit unserer Telefonanlage.
              Daher sind wir telefonisch aktuell nicht erreichbar.
              Auch der Anrufbeantworter ist von dieser Störung betroffen
            </p>

            <p class="mb-4">
              In dringenden Fällen, können sie uns gerne eine Email schreiben.
              Wir melden uns dann schnellstmöglich bei Ihnen.
            </p>

            <p class="mb-4">
              Vielen Dank für Ihr Verständnis!
            </p>

            <p class="mb-4">
              Herzliche Grüße<br />
              Romy Wagner
            </p>

            <button
                @click="showPopup = false"
                class="mt-4 px-4 py-2 bg-black text-white rounded"
            >
              Schließen
            </button>
          </div>

        </div>
      </div>
    </div>
    <img srcset="../assets/praxisbilder/hometeaser/home_teaser_small.png 600w,
         ../assets/praxisbilder/hometeaser/home_teaser_medium.png 1280w,
         ../assets/praxisbilder/hometeaser/home_teaser_large.png 2000w"
         src="../assets/praxisbilder/hometeaser/home_teaser_large.png"
        alt="hometeaser"/>
    <div class="grid grid-cols-12 mt-8 mb-12 ml-4 mr-4" id="kontakt">
      <div class="col-span-12 sm:col-span-10 sm:col-start-2 lg:col-span-8 lg:col-start-3">
        <Headline class="mb-8" content="Herzlich Willkommen bei Lautstark" />
        <h1>Lautstark Logopädie Romy Wagner - Herzlich willkommen in unserer neuen logopädischen Praxis!</h1>
        <div class="text mb-8">
          <p>
            Mit großer Freude und Engagement haben wir einen Ort geschaffen, an dem Sie und Ihre sprachlichen
            sowie kommunikativen Bedürfnisse im Mittelpunkt stehen. Unsere frisch eröffnete Praxis bietet ein
            breites Spektrum an logopädischen Therapien, die individuell auf Kinder, Jugendliche und Erwachsene
            abgestimmt sind. Ob Sprachentwicklungsverzögerungen, Stimmstörungen, Sprechprobleme oder
            Schluckbeschwerden – wir sind für Sie da, um Sie kompetent und einfühlsam zu begleiten.
          </p>
          <p>
            Unsere modernen, hellen Räumlichkeiten wurden mit viel Liebe zum Detail gestaltet, um eine angenehme
            Atmosphäre zu schaffen, in der Sie sich wohlfühlen können. Mit einer Kombination aus fachlicher
            Expertise, persönlichem Einsatz und moderner Therapieausstattung möchten wir gemeinsam mit
            Ihnen die besten Ergebnisse erzielen.
          </p>
          <p>
            Wir freuen uns darauf, Sie kennenzulernen und Sie auf Ihrem Weg zu mehr Lebensqualität
            und Ausdrucksfähigkeit zu unterstützen!
          </p>
        </div>
      </div>
    </div>
    <Romy />
  </div>
</template>

<script>
import Headline from "@/components/Headline.vue";
import Romy from "@/components/Romy.vue";
import {useHead} from "@vueuse/head";
import { ref } from "vue";

export default {
  name: "HomeView",
  components: {
    Headline,
    Romy
  },
  setup() {
    useHead({
      title: 'Lautstark Logopädie',
      meta: [
        {
          name: 'description',
          content: 'Willkommen in unserer Logopädischen Praxis in Troisdorf Spich! Wir bieten individuelle Therapie für Kinder und ' +
              'Erwachsene bei Sprach-, Sprech-, Stimm- und Schluckstörungen. Erfahren Sie mehr über unsere ' +
              'Leistungen und wie wir Ihnen helfen können, Ihre kommunikativen Fähigkeiten zu verbessern.'
        }
      ]
    })

    const today = new Date();
    const endDate = new Date(2026, 3, 11); // Monat 7 = August (0-basiert)

    const showPopup = ref(today <= endDate);

    return {
      showPopup,
    };
  }
};
</script>

<style lang="scss" scoped>
.content-wrapper {
  display: flex;
  width: 100vw;
  align-items: center;
  flex-direction: column;
}
.home {
  align-content: center;
}
.headline {
  flex: 1 0 auto;
  max-width: 1280px;
}
.text {
  flex: 1 0 0;
  text-align: left;
  max-width: 1280px;
  color: $color-text;
  padding: 0 $spacing-l
}
button {
  border-radius: 0 40px 40px 40px;
  background-color: $color-primary !important;
  font-family: $font-family-buttons !important;
  box-shadow: inset 0 4px 10px -5px rgba(0, 0, 0, 0.6);
  color: white !important;
  padding: $spacing-s !important;
  font-weight: bold !important;
}

.christmas {
  width: 100%;
  height: auto;
}

.popup {
  z-index: 1001;
}
</style>
